import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Button, Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import { API } from "../../../../../global/global";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import Header from "../../../../../components/HeaderForms/HeaderForms";

type Section = "ORDEN" | "LIMPIEZA" | "MOBILIARIO" | "DISTRIBUCIÓN";
type EspacioRating = "Muy Bien" | "Bien" | "Regular" | "Deficiente";

export const PropiedadCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "INMUEBLE CASA / DEPARTAMENTO";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<(File | null)[]>([null]);
  const [serviceSelection, setServiceSelection] = useState<string[]>([]);
  const [notes, setNotes] = useState<string>("");
  const [notesPage2, setNotesPage2] = useState<string>("");
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);

  const [ordenSeleccionado, setOrdenSeleccionado] = useState<string | null>(
    null
  );
  const [limpiezaSeleccionada, setLimpiezaSeleccionada] = useState<
    string | null
  >(null);
  const [mobiliarioSeleccionado, setMobiliarioSeleccionado] = useState<
    string | null
  >(null);
  const [distribucionSeleccionado, setDistribucionSeleccionado] = useState<
    string | null
  >(null);

  const [zonasSeleccionadas, setZonasSeleccionadas] = useState<{
    sala: boolean;
    cocina: boolean;
    recamaras: boolean;
    cochera: boolean;
    lavado: boolean;
    baniosCompletos: boolean;
    mediosBanios: boolean;
    jaula: boolean;
    balcones: boolean;
    patios: boolean;
  }>({
    sala: false,
    cocina: false,
    recamaras: false,
    cochera: false,
    lavado: false,
    baniosCompletos: false,
    mediosBanios: false,
    jaula: false,
    balcones: false,
    patios: false,
  });

  const [serviciosSeleccionados, setServiciosSeleccionados] = useState<{
    agua: boolean;
    drenaje: boolean;
    transporte: boolean;
    vigilancia: boolean;
    telefono: boolean;
    luz: boolean;
    pavimentacion: boolean;
  }>({
    agua: false,
    drenaje: false,
    transporte: false,
    vigilancia: false,
    telefono: false,
    luz: false,
    pavimentacion: false,
  });

  const [espacioSeleccionado, setEspacioSeleccionado] = useState<string | null>(
    null
  );

  const [formData, setFormData] = useState({});

  const [selectedRatings, setSelectedRatings] = useState({
    ORDEN: "",
    LIMPIEZA: "",
    MOBILIARIO: "",
    DISTRIBUCIÓN: "",
  });

  const [selectedEspacioRating, setSelectedEspacioRating] = useState<
    EspacioRating | ""
  >("");

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [null]);
    setCurrentPage(newPage);
  };

  const handleServiceChange = (service: string) => {
    setServiceSelection((prev) => {
      const newServices = prev.includes(service)
        ? prev.filter((s) => s !== service)
        : [...prev, service];
      return newServices;
    });
  };

  const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newNotes = event.target.value;
    setNotes(newNotes);
  };

  const handleNotesPage2Change = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const newNotes = event.target.value;
    setNotesPage2(newNotes);
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
      cp: "",
    };
    setFormData(emptyFormData);
    setSelectedRatings({
      ORDEN: "",
      LIMPIEZA: "",
      MOBILIARIO: "",
      DISTRIBUCIÓN: "",
    });
    setSelectedEspacioRating("");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);
    }
  };

  const handleRatingChange = (section: string, rating: string) => {
    const updatedRatings = { ...selectedRatings, [section]: rating };
    setSelectedRatings(updatedRatings);
  };

  const handleEspacioChange = (espacio: string) => {
    setEspacioSeleccionado(espacio);
  };

  const handleOrdenChange = (orden: string) => {
    setOrdenSeleccionado(orden);
  };

  const handleMobiliarioChange = (option: string) => {
    setMobiliarioSeleccionado(option);
  };

  const handleDistribucionChange = (option: string) => {
    setDistribucionSeleccionado(option);
  };

  const handleLimpiezaChange = (limpieza: string) => {
    setLimpiezaSeleccionada(limpieza);
  };

  const handleZonaChange = (zona: string, valor: boolean) => {
    setZonasSeleccionadas((prev) => ({ ...prev, [zona]: valor }));
  };

  const handleServicioChange = (servicio: string, valor: boolean) => {
    setServiciosSeleccionados((prev) => ({ ...prev, [servicio]: valor }));
  };

  const addImageBox = () => {
    setImages([...images, null]);
  };

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const sendPhotoToBackend = async (formData: FormData) => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        `${API}/evaluado/${evaluadosList_id}/ubicacion`,
        {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.log("Imagen subida exitosamente");
      } else {
        console.error("Error al subir la imagen", response.statusText);
      }
    } catch (error) {
      console.error("Error en la petición", error);
    }
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const mutateFecha = useMutationData({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-visita-bienesinmuebles"],
  });

  const mutateInteriorInmueble = useMutationData({
    url: `/interior-inmueble/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "interior-inmueble"],
  });

  const mutateZonaInmueble = useMutationData({
    url: `/zonas_inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "zonas_inmueblecasa"],
  });

  const mutateEspacioInmueble = useMutationData({
    url: `/espacio-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "espacio-inmueblecasa"],
  });

  const mutateServiciosInmueble = useMutationData({
    url: `/servicios-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "servicios-inmueblecasa"],
  });

  const mutateNotasInmuebles = useMutationData({
    url: `/notas-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "notas-inmueblecasa"],
  });

  const mutateUbicacionVD = useMutationData({
    url: `/evaluado/${evaluadosList_id}/ubicacion`,
    reload: ["evaluado", `${evaluadosList_id}`, "ubicacion"],
  });

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const domicilio = `${queryEvaluado.data?.calle || ""}, ${
    queryEvaluado.data?.numero_exterior || ""
  }, ${queryEvaluado.data?.colonia || ""}, ${
    queryEvaluado.data?.codigo_postal || ""
  }, ${queryEvaluado.data?.municipio || ""}, ${
    queryEvaluado.data?.estado || ""
  }, ${queryEvaluado.data?.pais || ""}`;

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        codigo_postal: queryEvaluado.data.codigo_postal || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_inmueblecasa" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA VISITA:
          </Label>
          <Controller
            name="fecha_inmueblecasa"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_inmueblecasa"
                type="date"
                placeholder="Seleccionar fecha"
                {...field}
                className={`w-32 ${isDarkMode ? "bg-gray-700 text-white" : "bg-white text-gray-700"}`}
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={generoTexto}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">INTERIOR DEL INMUEBLE</h2>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {(["ORDEN"] as Section[]).map((item1) => (
          <div key={item1} className={`rounded-lg mb-4 border ${isDarkMode ? "border-gray-700" : "border-gray-300"}`}>
            <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
              <h3 className="font-bold text-lg">{item1}</h3>
            </div>
            <div className={`grid grid-cols-4 gap-4 p-4 ${isDarkMode ? "bg-gray-700" : "bg-white"}`}>
              {["Muy Bien", "Bien", "Regular", "Deficiente"].map((option1) => (
                <div key={option1} className="flex items-center space-x-2">
                  <Checkbox
                    id={`orden${option1}`}
                    checked={ordenSeleccionado === option1}
                    onChange={() => handleOrdenChange(option1)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                  <Label htmlFor={`orden${option1}`} className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                    {option1}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        ))}
        {(["LIMPIEZA"] as Section[]).map((item2) => (
          <div key={item2} className={`rounded-lg mb-4 border ${isDarkMode ? "border-gray-700" : "border-gray-300"}`}>
            <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
              <h3 className="font-bold text-lg">{item2}</h3>
            </div>
            <div className={`grid grid-cols-4 gap-4 p-4 ${isDarkMode ? "bg-gray-700" : "bg-white"}`}>
              {["Muy Bien", "Bien", "Regular", "Deficiente"].map((option2) => (
                <div key={option2} className="flex items-center space-x-2">
                  <Checkbox
                    id={`limpieza${option2}`}
                    checked={limpiezaSeleccionada === option2}
                    onChange={() => handleLimpiezaChange(option2)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                  <Label
                    htmlFor={`limpieza${option2}`}
                    className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
                  >
                    {option2}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        ))}
        {(["MOBILIARIO"] as Section[]).map((item3) => (
          <div key={item3} className={`rounded-lg mb-4 border ${isDarkMode ? "border-gray-700" : "border-gray-300"}`}>
            <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
              <h3 className="font-bold text-lg">{item3}</h3>
            </div>
            <div className={`grid grid-cols-4 gap-4 p-4 ${isDarkMode ? "bg-gray-700" : "bg-white"}`}>
              {["Muy Bien", "Bien", "Regular", "Deficiente"].map((option3) => (
                <div key={option3} className="flex items-center space-x-2">
                  <Checkbox
                    id={`mobiliario${option3}`}
                    checked={mobiliarioSeleccionado === option3}
                    onChange={() => handleMobiliarioChange(option3)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                  <Label
                    htmlFor={`mobiliario${option3}`}
                    className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
                  >
                    {option3}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        ))}
        {(["DISTRIBUCIÓN"] as Section[]).map((item4) => (
          <div key={item4} className={`rounded-lg mb-4 border ${isDarkMode ? "border-gray-700" : "border-gray-300"}`}>
            <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
              <h3 className="font-bold text-lg">{item4}</h3>
            </div>
            <div className={`grid grid-cols-4 gap-4 p-4 ${isDarkMode ? "bg-gray-700" : "bg-white"}`}>
              {["Muy Bien", "Bien", "Regular", "Deficiente"].map((option4) => (
                <div key={option4} className="flex items-center space-x-2">
                  <Checkbox
                    id={`distribucion${option4}`}
                    checked={distribucionSeleccionado === option4}
                    onChange={() => handleDistribucionChange(option4)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                  <Label
                    htmlFor={`distribucion${option4}`}
                    className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
                  >
                    {option4}
                  </Label>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="mb-4">
        <Label
          htmlFor="nota_inmueblecasa"
          className={`block font-bold ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}
        >
          NOTAS:
        </Label>
        <Controller
          name="nota_inmueblecasa"
          control={control}
          defaultValue=""
          render={({ field: { value, onChange, ...field } }) => (
            <Textarea
              id="nota_inmueblecasa"
              {...field}
              value={value}
              rows={4}
              onChange={(e) => {
                onChange(e);
                handleNotesPage2Change(e);
              }}
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              className={`mt-2 p-2 border rounded-md resize-none ${isDarkMode ? "bg-gray-700 border-gray-600 text-white" : "bg-white border-gray-300"}`}
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
    </div>
  );

  const renderPage3 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">ZONAS DEL INMUEBLE</h2>
      </div>

      <div className={`grid grid-cols-2 gap-6 p-4 ${isDarkMode ? "bg-gray-700 rounded-b-lg" : "bg-white"}`}>
        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="sala_comedor"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="sala_comedor"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Sala comedor</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="cocina"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="cocina"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Cocina</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="recamaras"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="recamaras"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Recámaras</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="cochera"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="cochera"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Cochera</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="area_lavado"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="area_lavado"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Área de lavado</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="banios_completos"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="banios_completos"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Baños completos</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="medios_banios"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="medios_banios"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Medios baños</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="jaula_tendido"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="jaula_tendido"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Jaula de tendido</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="balcones"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="balcones"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Balcones</span>
        </label>

        <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
          <Controller
            name="patios"
            control={control}
            defaultValue={false}
            render={({ field: { onChange, value, ...field } }) => (
              <Checkbox
                id="patios"
                {...field}
                checked={!!value}
                onChange={(e) => onChange(e.target.checked)}
                className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
              />
            )}
          />
          <span>Patios</span>
        </label>
      </div>

      <div className="mt-4 space-y-4">
        <div>
          <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
            <h3 className="font-bold text-lg">ESPACIO</h3>
          </div>
          <div className={`grid grid-cols-4 gap-4 p-4 border rounded-b-lg ${isDarkMode ? "bg-gray-700 border-gray-700" : "bg-white border-gray-300"}`}>
            {["Sobrado", "Suficiente", "Insuficiente"].map((espacio) => (
              <div key={espacio} className="flex items-center space-x-2">
                <Checkbox
                  id={`espacio_del_inmueblecasa${espacio}`}
                  checked={espacioSeleccionado === espacio}
                  onChange={() => handleEspacioChange(espacio)}
                  className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                />
                <Label
                  htmlFor={`espacio_del_inmueblecasa${espacio}`}
                  className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
                >
                  {espacio}
                </Label>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className={`p-2 rounded-t-lg ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
            <h3 className="font-bold text-lg">SERVICIOS</h3>
          </div>
          <div className={`grid grid-cols-3 gap-4 p-4 border rounded-b-lg ${isDarkMode ? "bg-gray-700 border-gray-700" : "bg-white border-gray-300"}`}>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="agua"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="agua"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Agua</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="drenaje"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="drenaje"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Drenaje</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="transporte"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="transporte"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Transporte</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="vigilancia"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="vigilancia"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Vigilancia</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="telefono"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="telefono"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Teléfono</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="luz"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="luz"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Luz</span>
            </label>
            <label className={`flex items-center space-x-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <Controller
                name="pavimentacion"
                control={control}
                defaultValue={false}
                render={({ field: { onChange, value, ...field } }) => (
                  <Checkbox
                    id="pavimentacion"
                    {...field}
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                    className={`${isDarkMode ? "bg-gray-600 border-gray-500" : "border-gray-300"}`}
                  />
                )}
              />
              <span>Pavimentación</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );

  const imageUrl = `http://localhost:8000/storage/evaluados/photos/${evaluadosList_id}/Croquis.png`;
  const renderPage4 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900"}`}>
      <h2 className={`text-lg font-semibold mb-4 ${isDarkMode ? "text-white" : "text-gray-900"}`}>Ubicación en el Mapa</h2>
      <TextInput
        id="domicilio"
        name="domicilio"
        onChange={handleInputChange}
        value={domicilio}
        disabled={true}
        className={`${isDarkMode ? "bg-gray-700 text-gray-300" : "bg-gray-100 text-gray-800"}`}
      />
      {/* Mostrar la imagen si existe */}
      <div className="mt-4">
        <h3 className={`text-md font-medium ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>Imagen del Croquis:</h3>
        <div className="flex justify-center mt-2">
          <img
            src={imageUrl}
            alt="Croquis"
            className={`w-full max-w-md h-auto rounded-lg ${isDarkMode ? "border-2 border-gray-600" : "border-2 border-gray-300"}`}
          />
        </div>
      </div>
      <div className={`mt-4 p-4 border-t ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}>
        <div className="text-center">
          <p className={`text-left text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos.
          </p>
          <p className={`text-left text-sm ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
            Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
            C.V. para que proporcione toda la Información, documentos y todos
            los datos que derive de las evaluaciones de pruebas de confianza que
            se me realicen.
          </p>
        </div>
      </div>
    </div>
  );

    return (
      <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
        <div className={`container mx-auto p-4`}>
          <form
            onSubmit={handleSubmit(async (data) => {
              const formData = {
                ...data,
                orden: ordenSeleccionado,
                limpieza: limpiezaSeleccionada,
                mobiliario: mobiliarioSeleccionado,
                distribucion: distribucionSeleccionado,
                zonaS: zonasSeleccionadas.sala,
                zonaC: zonasSeleccionadas.cocina,
                zonaR: zonasSeleccionadas.recamaras,
                zonaCh: zonasSeleccionadas.cochera,
                zonaL: zonasSeleccionadas.lavado,
                zonaBC: zonasSeleccionadas.baniosCompletos,
                zonaMB: zonasSeleccionadas.mediosBanios,
                zonaJ: zonasSeleccionadas.jaula,
                espacio_del_inmueblecasa: espacioSeleccionado,
                servicios_del_inmueblecasaAgua: serviciosSeleccionados.agua,
                servicios_del_inmueblecasaDrenaje: serviciosSeleccionados.drenaje,
                servicios_del_inmueblecasaTransporte:
                  serviciosSeleccionados.transporte,
                servicios_del_inmueblecasaVigilancia:
                  serviciosSeleccionados.vigilancia,
                servicios_del_inmueblecasaTelefono: serviciosSeleccionados.telefono,
                servicios_del_inmueblecasaLuz: serviciosSeleccionados.luz,
                servicios_del_inmueblecasaPavimentacion:
                  serviciosSeleccionados.pavimentacion,
              };

              const formDataImages = new FormData();
              images.forEach((image, index) => {
                if (image instanceof File && image.size > 0) {
                  console.log("Agregando imagen al formData:", image);
                  formDataImages.append("ubicacion", image);
                } else {
                  console.log("Imagen vacía o no válida en el índice", index);
                }
              });

              // Mutación para guardar la Fecha
              mutateFecha.mutate(
                {
                  data: formData,
                  tipo: "put",
                },
                {
                  onSuccess: () => {
                    mutateInteriorInmueble.mutate(
                      {
                        data: formData,
                        tipo: "post",
                      },
                      {
                        onSuccess: () => {
                          mutateNotasInmuebles.mutate(
                            {
                              data: formData,
                              tipo: "post",
                            },
                            {
                              onSuccess: () => {
                                mutateZonaInmueble.mutate(
                                  {
                                    data: formData,
                                    tipo: "post",
                                  },
                                  {
                                    onSuccess: () => {
                                      mutateEspacioInmueble.mutate(
                                        {
                                          data: formData,
                                          tipo: "post",
                                        },
                                        {
                                          onSuccess: () => {
                                            mutateServiciosInmueble.mutate(
                                              {
                                                data: formData,
                                                tipo: "post",
                                              },
                                              {
                                                onSuccess: () => {
                                                  sendPhotoToBackend(
                                                    formDataImages
                                                  );
                                                  navigate(
                                                    `/domiciliaria/${evaluadosList_id}`
                                                  );
                                                },
                                              }
                                            );
                                          },
                                        }
                                      );
                                    },
                                  }
                                );
                              },
                            }
                          );
                        },
                      }
                    );
                  },
                  onError: (error) => {
                    console.error("Error al guardar Fecha:", error);
                  },
                }
              );
            })}
            className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
          >
            {renderHeader()}

            {currentPage === 1 && renderPage1()}
            {currentPage === 2 && renderPage2()}
            {currentPage === 3 && renderPage3()}
            {currentPage === 4 && renderPage4()}

            <div className={`mt-6 p-4 flex justify-between ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
              {currentPage < 2 && (
                <Button
                  color="red"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate(`/domiciliaria/${evaluadosList_id}`);
                  }}
                  className={`${isDarkMode ? "bg-red-600 hover:bg-red-700 text-white" : "bg-red-500 hover:bg-red-600 text-white"}`}
                >
                  Cancelar
                </Button>
              )}
              {currentPage > 1 && (
                <button
                  type="button"
                  className={`rounded px-4 py-2 transition-colors ${isDarkMode ? "bg-violet-600 text-white hover:bg-violet-700" : "bg-violet-300 text-white-700"}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    handlePageChange(currentPage - 1);
                  }}
                >
                  Anterior
                </button>
              )}
              {currentPage < 4 && (
                <button
                  type="button"
                  className={`rounded px-4 py-2 transition-colors ${isDarkMode ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-blue-500 text-white"}`}
                  onClick={() => {
                    window.scrollTo(0, 0);
                    handlePageChange(currentPage + 1);
                  }}
                >
                  Siguiente
                </button>
              )}
              {currentPage === 4 && (
                <div className="flex space-x-4">
                  <button
                    type="submit"
                    className={`rounded px-4 py-2 transition-colors ${isDarkMode ? "bg-green-600 text-white hover:bg-green-700" : "bg-green-500 text-white"}`}
                  >
                    Guardar
                  </button>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>  
  );
};
